import { authKey, orgKey } from "@/hooks/useAuth";
import { env } from "@/utils/env";
import axiosBase from "axios";

export function buildHonoHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem(authKey)}`,
    "x-org-id": localStorage.getItem(orgKey) || "",
  };
}

export const honoAxios = axiosBase.create({
  baseURL: env.VITE_HONO_URL,
  headers: buildHonoHeaders(),
});
